import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-start gap-3">
        <span className="mt-1 h-6 w-1 rounded-full bg-accent-500" aria-hidden="true" />
        <div>
          <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className="group inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </Link>
      ) : null}
    </div>
  );
}